import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CrudGenericsService } from '../common/crud-generics';
import { Environment, MacchineCaratteristiche, IMacchineCaratteristicheLng, ModelNumStr } from '../../models/-index';

@Injectable()
export class MacchineCaratteristicheService extends CrudGenericsService<MacchineCaratteristiche, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/MacchineCaratteristiche`);
    this.base = `${env.apiUrl}/api/MacchineCaratteristiche/`;
  }

  GetMacchineCaratteristiche_Codici(): Observable<ModelNumStr[]> {
    const url = this.base + 'GetMacchineCaratteristiche_Codici';
    return this.http.get<ModelNumStr[]>(`${url}`);
  }
  // web
  GetAll_MacchineCaratteristicheLng(): Observable<IMacchineCaratteristicheLng[]> {
    const url = this.base + 'GetAll_MacchineCaratteristicheLng';
    return this.http.get<IMacchineCaratteristicheLng[]>(`${url}`);
  }
}
